import Vue from 'vue'
import Router from 'vue-router'
import mainPage from '@/components/mainPage'
import pages from '@/components/pages'
import fwUpgrade from '@/components/fwUpgrade'

Vue.use(Router)

export default new Router({
  history: false,
  props: ['id', 'page', 'data', 'operation'],
  routes: [
    {
      path: '/',
      component: mainPage
    },
    {
      path: '/pages/:id',
      component: pages,
      props: true
    },
    {
      path: '/fwUpgrade/:id',
      component: fwUpgrade,
      props: true
    }
  ]
})
